/* src/app/shared/date-navigator/date-navigator.component.scss */
.date-navigator-container {
  margin: 2rem 0 1rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}
.date-navigator-container #date-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-left: 0.5rem;
}
.date-navigator-container #date-title span {
  display: inline-block;
}
.date-navigator-container #date-title span:first-letter {
  text-transform: uppercase;
}
.date-navigator-container .date-navigator-left,
.date-navigator-container .date-navigator-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.date-navigator-container .date-navigator-picker {
  display: flex;
  align-items: center;
  justify-content: center;
}
.date-navigator-container .visually-hidden {
  position: absolute;
  width: 0;
  height: 0;
  margin: 0;
  border: 0;
  padding: 0;
  white-space: nowrap;
  clip: rect(0 0 0 0);
  clip-path: inset(100%);
  overflow: hidden;
}
.mini-fab-extended {
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 4px;
  min-width: auto;
  width: auto;
  height: 40px;
  border-radius: 2rem !important;
}
.mini-fab-label {
  font-size: 14px;
  white-space: nowrap;
}
/*# sourceMappingURL=date-navigator.component.css.map */
